module.exports = {"pathContext":{}}


//////////////////
// WEBPACK FOOTER
// ./~/json-loader!./.cache/json/sponsorchallenges.json
// module id = 1042
// module chunks = 216378638584863